import { render, staticRenderFns } from "./UploadDepositRemitAcc.vue?vue&type=template&id=9863ddee&scoped=true"
import script from "./UploadDepositRemitAcc.vue?vue&type=script&lang=js"
export * from "./UploadDepositRemitAcc.vue?vue&type=script&lang=js"
import style0 from "./UploadDepositRemitAcc.vue?vue&type=style&index=0&id=9863ddee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9863ddee",
  null
  
)

export default component.exports